module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB4AAAAK8AQMAAAA07DD0AAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAANNJREFUeNrswYEAAAAAgKD9qRepAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABg9uBAAAAAAADI/7URVFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVWlPTggAQAAABD0/3U/QgUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPYCkxoAAXH+Z5QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/img-maskCover.png
// module id = 549
// module chunks = 0